/**
 * Generated runtime TestId mirror for frontend/src/pages/Dashboard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const DashboardCardId = {
  AccessGovernance: "access-governance",
  AccessProvisioning: "access-provisioning",
  AuditLog: "audit-log",
  BackgroundJobs: "background-jobs",
  Connectors: "connectors",
  EffectiveAccess: "effective-access",
  IamAdmin: "iam-admin",
  IdentityManagement: "identity-management",
  MyIam: "my-iam",
  Reporting: "reporting",
  Schema: "schema",
  TargetSystems: "target-systems",
} as const;
export type DashboardCardId = typeof DashboardCardId[keyof typeof DashboardCardId];

export const DashboardTestIds = {
  dashboardPage: "dashboard-page",
  dashboardCard: (subtype: DashboardCardId) => `dashboard-card-${subtype}` as const,
  dashboardCardPrefix: () => "dashboard-card-" as TestIdPrefix,
  dashboardCardTitle: (subtype: DashboardCardId) => `dashboard-card-title-${subtype}` as const,
  dashboardCardTitlePrefix: () => "dashboard-card-title-" as TestIdPrefix
} as const;
